<script setup>
import { usePage } from "@inertiajs/vue3";

import MaterialIcon from "../MaterialIcon.vue";

const props = defineProps({
  collapse: {
    type: Boolean,
    required: false,
    default: false,
  },
  href: String,
  icon_name: String,
  text: String,
  children: {
    type: Object,
    required: false,
    default: undefined,
  },
});

const page = usePage();

const isActive = (href) => {
  // get route of href
  const navUrl = new URL(href, window.location.origin);
  const currentUrl = new URL(page.url, window.location.origin);
  let navRouteName = navUrl.pathname.split("/").slice(1, 2).join("/");
  let currentRouteName = currentUrl.pathname.split("/").slice(1, 2).join("/");
  if (navRouteName === currentRouteName) {
    if (navRouteName === "invoices") {
      // get outgoing query parameters
      if (
        navUrl.searchParams.get("outgoing") ===
        currentUrl.searchParams.get("outgoing")
      )
        return true;
      else return false;
    } else return true;
  } else return false;
};
</script>

<script>
export default {
  name: "NavLink",
};
</script>

<template>
  <div>
    <Link
      :href="href"
      class="link"
      :class="[isActive(href) ? 'active' : '', collapse ? 'collapsed' : '']"
    >
      <MaterialIcon :icon_name="icon_name">
        <template #tooltip v-if="collapse">
          {{ text }}
        </template>
      </MaterialIcon>
      <span v-show="!collapse" class="label">
        {{ text }}
      </span>
    </Link>
    <div v-if="children !== undefined" :class="collapse ? '' : 'indent'">
      <ul>
        <li class="indent-link" v-for="child in children" :key="child.text">
          <NavLink
            :collapse="collapse"
            :href="child.href"
            :text="child.text"
            :icon_name="child.icon_name"
            :children="child.children"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
ul {
  li {
    margin-top: 0.25rem;
  }
}
.indent {
  padding-left: 2rem;

  .indent-link {
    position: relative;
  }
}

.indent-link::before {
  content: "";
  border-bottom: solid 1px var(--clr-bg-menu-accent);
  border-left: solid 1px var(--clr-bg-menu-accent);
  width: 0.75rem;
  height: 50%;
  position: absolute;
  left: -1.25rem;
}

.indent-link + .indent-link::before {
  height: 100%;
  transform: translateY(-50%);
}

.link {
  @include ff-menu;
  @include rounded-borders-lg;

  align-items: center;
  display: flex;

  padding: 0.5rem 0.75rem;
  margin-left: -0.75rem;
  margin-right: -0.75rem;

  transition: background-color 200ms ease-in;

  &.collapsed {
    justify-content: center;
  }

  & > * + * {
    margin-left: 0.5rem;
  }

  &:hover,
  &:focus-visible {
    background-color: var(--clr-bg-menu-accent);
  }

  &.active {
    background-color: var(--clr-bg-dark);
    color: var(--clr-text-light);
  }
}
</style>
